import type { FeedbackMessages } from './en';

const bg: FeedbackMessages = {
  qualified: {
    title: 'Благодарим Ви, че попълнихте това проучване!',
    body1: 'Можете спокойно да затворите прозореца на браузъра.',
    body2: 'Надяваме се да Ви видим отново скоро.',
    refCode: 'Референтен код: {code}',
  },
  quotaFull: {
    title: 'Това проучване е затворено',
    body1: 'Благодарим Ви за интереса към нашето проучване.',
    body2: 'За съжаление вече получихме всички отговори, от които се нуждаем.',
    body3: 'Надяваме се да Ви видим в едно от бъдещите ни проучвания!',
    refCode: 'Референтен код: {code}',
  },
  terminated: {
    title: 'Благодарим Ви, че споделихте своето мнение!',
    body1:
      'Надяваме се да Ви видим скоро в бъдещите ни проучвания. Дотогава Ви желаем прекрасен ден.',
    body2: 'Моля, затворете прозореца на браузъра.',
    refCode: 'Референтен код: {code}',
  },
  mismatch: {
    title: 'Благодарим Ви за интереса',
    body1: 'За съжаление не спадате към целевата група за това конкретно проучване.',
    body2: 'Можете да затворите тази страница.',
    code: 'Код: {code}',
  },
  error: {
    title: 'Не можем да обработим Вашата заявка',
    linkProblemDetailed:
      'Връзката, която сте последвали, има проблем. Моля, проверете дали връзката в адресната лента съответства на тази, която Ви е предоставена, и опитайте отново.',
    linkProblemGeneric:
      'Връзката, която сте последвали, има проблем. Моля, опитайте отново.',
    contactPerson:
      'Ако проблемът продължава, моля, уведомете лицето, от което сте получили връзката, за този проблем.',
    errorCode: 'Код на грешка: {code}',
  },
};

export default bg;
